<script setup lang="ts">
withDefaults(defineProps<{
  title?: string
  description?: string
}>(), {
  title: 'Vi jobber med saken',
  description: 'Denne funksjonen er foreløpig ikke tilgjengelig i den nye løsningen, men vi etter hvert samles her.',
})
</script>

<template>
  <div class="flex flex-col lg:flex-row gap-m lg:gap-3xl max-w-3xl mx-auto">
    <div class="flex items-center justify-center w-[195px] h-[195px] mx-auto">
      <IllustrationVector />
    </div>
    <div v-if="title || description" class="flex flex-col gap-2xs items-center lg:items-start justify-center">
      <h3 v-text="title" />
      <p v-if="description" class="text-body font-normal text-center lg:text-left" v-text="description" />
    </div>
  </div>
</template>
